import {isArray} from '@apollo/client/cache/inmemory/helpers';
import {PibisiContent} from 'api/generated';
import {AnchorLink, Property, PropertyList} from 'components';
import humanize from 'humanize-string';
import {formatDate} from 'lib/formaters';
import {enumKeys} from 'lib/utils';
import moment from 'moment';
import React from 'react';

type Props = {
  content?: PibisiContent | null;
};

const formatFlagProp = ({label, value}: Property) => {
  if (!value) {
    return {label: null, value: null};
  }
  if (label === 'url') {
    return {
      label: humanize(label),
      value: (
        <AnchorLink href={value} target="_blank">
          {value}
        </AnchorLink>
      )
    };
  }
  if (moment(value, 'YYYY-MM-DD', true).isValid()) {
    return {
      label: humanize(label),
      value: formatDate(value)
    };
  }
  if (typeof value === 'string') {
    return {
      label: humanize(label),
      value: humanize(value)
    };
  }
  if (isArray(value)) {
    return {
      label: humanize(label),
      value: value.map((v) => humanize(v)).join(', ')
    };
  }
  return {
    label: humanize(label),
    value: value
  };
};

export const FlagContent: React.FC<Props> = ({content}) => {
  if (!content) return null;
  return (
    <PropertyList
      omitEmpty
      properties={enumKeys(content)
        .filter((key) => key !== '__typename')
        .map((key) => {
          return formatFlagProp({label: key, value: content[key]});
        })}
    />
  );
};
